module.exports = __webpack_public_path__ + "5c78b01f05acb5a0ceb3a5452d1d9052.svg";